import React, { FC, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from 'store/storeHooks';
import { menuItems } from 'menu/MenuItems';
import PowerplantDropdown from './PowerplantDropdown/PowerplantDropdown';
import UserDropdown from './UserDropdown/UserDropdown';
import { useAuthStatus } from 'auth/useAuthStatus';

import cn from 'classnames';
import styles from './TydeHeader.module.scss';

interface TydeHeaderProps {}
export const TydeHeader: FC<TydeHeaderProps> = () => {

  const location = useLocation();
  const { isAuthenticated } = useAuthStatus();

  const initialHeaderTitle = menuItems.find(item => item.route === location.pathname)?.headerTitle || menuItems.find(item => item.route === location.pathname)?.title || '';

  const [headerTitle, setHeaderTitle] = useState<string>(initialHeaderTitle);

  const sideMenu = useAppSelector(state => state.sideMenu);

  useEffect(() => {
    const matchingItem = menuItems.find(entry => entry.route === location.pathname);
    if (matchingItem) {
      setHeaderTitle(matchingItem.headerTitle || matchingItem.title);
    }
  }, [location.pathname]);

  return (
    <header className={cn(styles.TydeHeader, {
      [styles.withSideMenuExpanded]: isAuthenticated && sideMenu.isExpanded,
      [styles.withSideMenu]: isAuthenticated && !sideMenu.isExpanded,
    })}>

      <div className={styles.pageTitle}>
        { !isAuthenticated && 'Tyde3' }
        { isAuthenticated && headerTitle }
      </div>

      <section className={styles.controls}>
        { isAuthenticated && <PowerplantDropdown />}
        <UserDropdown />
      </section>
    </header>
  );
}
